export enum Popups {
  PAYMENT_POPUP = 'PAYMENT_POPUP',
  STATUS_POPUP = 'STATUS_POPUP',
  FORM_POPUP = 'FORM_POPUP',
}

export enum PopupsStatus {
  STATUS_POPUP = 'STATUS_POPUP',
}
